import {
	ComponentRef,
	Directive,
	OnInit,
	ViewContainerRef,
	inject,
	HostAttributeToken,
	input,
	effect,
	Injector,
	runInInjectionContext,
	output,
} from '@angular/core';
import { FilterService } from '../services/filter.service';

import { FilterComponent } from '../filters/filter-component';
import { FilterName } from '../services/filter-name';

@Directive({
	selector: '[appFilterInput]',
})
export class FilterInputDirective<T> implements OnInit {
	readonly viewContainerRef = inject(ViewContainerRef);
	private readonly filterService = inject(FilterService);
	private readonly injector = inject(Injector);

	filterName = input.required<FilterName>();

	searchInput = input<string | undefined>(undefined);

	searchInputChange = output<string>();

	inDropdown: boolean;

	private componentRef!: ComponentRef<FilterComponent<T>>;

	constructor() {
		const inDropdown = inject(new HostAttributeToken('in-dropdown'), { optional: true });

		this.inDropdown = inDropdown !== null;
	}

	ngOnInit() {
		const container = this.viewContainerRef;
		const componentType = this.inDropdown
			? this.filterService.getDropdownComponent(this.filterName())
			: this.filterService.configs[this.filterName()]!.component;
		this.componentRef = container.createComponent(componentType);
		this.componentRef.instance.filterName = this.filterName();
		this.componentRef.instance.inDropdown = this.inDropdown;
		this.componentRef.instance.searchInputChange?.subscribe((value) => this.searchInputChange.emit(value));

		this.componentRef.instance.searchInput.set(this.searchInput());

		runInInjectionContext(this.injector, () => {
			effect(() => this.componentRef.instance.searchInput.set(this.searchInput()));
		});
	}
}
